





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { NetworkTemplate } from '@/types';
import NetworkTemplateForm from './NetworkTemplateForm.vue';

@Component({
  name: 'network-templates',
  components: {
    NetworkTemplateForm
  }
})
export default class NetworkTemplates extends Vue {
  @Prop({ type: Array, required: true, default: () => [] })
  private templates!: NetworkTemplate[];

  @Prop({ required: true })
  private networkId!: number;

  private thisTemplates: NetworkTemplate[] = this.templates;
  private newTemplate: NetworkTemplate = {
    id: undefined,
    affiliate_network: {
      id: this.networkId
    },
    status: 'active',
    template: ''
  };

  deleteNetworkTemplate(template: NetworkTemplate) {
    const idx = this.thisTemplates!.findIndex(
      (l: NetworkTemplate) => l.id === template.id
    );
    if (idx !== -1) {
      this.thisTemplates.splice(idx, 1);
    }
  }

  addNetworkTemplate(template: NetworkTemplate) {
    this.thisTemplates.push(template);
  }
}
